'use client';

import { Image } from '@coolblue-development/next-image/client';
import { useBreakpoints } from '@hooks/useBreakpoints';

type ProductImageProps = {
  primaryImage: {
    id: string;
  };
  name: string;
  isSecondChance?: boolean;
};

export default function ProductImage({ primaryImage, name, isSecondChance }: ProductImageProps) {
  const { isMobile } = useBreakpoints();

  return (
    <Image
      imageId={primaryImage.id}
      fileCollection={isSecondChance ? 'second_chance_product' : 'product'}
      width={isMobile ? 110 : 200}
      height={isMobile ? 100 : 160}
      background='transparent'
      objectFit='contain'
      alt={name || ''}
      loading='lazy'
      sizes='125px'
    />
  );
}
